import React from 'react';
import { Box, xcss, Text } from '@atlaskit/primitives';
import { components, type GroupHeadingProps } from '@atlaskit/react-select';
import { ALL_COLUMNS_ID } from '../../constants.tsx';
import type { SelectOption } from '../../../../common/types.tsx';

export type Props = GroupHeadingProps<SelectOption> & {
	data: { label?: string | undefined; id?: string };
	totalCount: number | null;
};

const HeadingContent = ({ label, totalCount }: { label?: string; totalCount?: number | null }) => {
	return (
		<Box xcss={groupHeadingStyles} paddingBlockEnd="space.075" paddingInline="space.200">
			<Text size="small" weight="bold" color="color.text.subtle">
				{label?.toLocaleUpperCase()}
			</Text>
			{totalCount && (
				<Text size="small" color="color.text.subtle">
					{totalCount}
				</Text>
			)}
		</Box>
	);
};

export const GroupHeading = ({ data, totalCount, ...restProps }: Props) => {
	const { id, label } = data;
	switch (id) {
		case ALL_COLUMNS_ID:
			return <HeadingContent label={label} totalCount={totalCount} />;

		default:
			return <components.GroupHeading {...restProps} data={data} />;
	}
};

const groupHeadingStyles = xcss({
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'space-between',
});
